import React from "react"
import AutomateFollowUpGraphic from "../../../../images/icons/automateYourEfforts/automateFollowUpGraphic.svg"
import CaptureLeadsGraphic from "../../../../images/icons/automateYourEfforts/captureLeadsGraphic.png"
import ArrowGraphic from "../../../../images/icons/automateYourEfforts/double-arrows.svg"
import CaptureLeadsImage from "../../../../components/staticQuery/home/CaptureLeadsImage"
import SendDigitalOffersImage from "../../../../components/staticQuery/home/SendDigitalOffersImage"

const automateYourEffortsData = [
  {
    component: <CaptureLeadsImage />,
    title: "Capture Leads",
  },
  {
    icon: ArrowGraphic,
  },
  {
    component: <SendDigitalOffersImage />,
    title: "Send Digital Offers",
  },
  {
    icon: ArrowGraphic,
  },
  {
    graphic: AutomateFollowUpGraphic,
    title: "Automate Follow-Up",
  },
]

export default automateYourEffortsData
